import { Box, Card, CardContent, Divider, Grid, Modal, Typography } from "@mui/material";
import { ModalHeader } from "../../common/modalHeader";
import { useEffect } from "react";

export const EmployeeViewReceipt = ({ modalData, open, setOpen }) => {
  useEffect(() => {
    let data = modalData;
    console.log("openModal ", data);
  }, [modalData]);
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: "52%",
          overflowY: "auto",
          height: "90vh",
          position: "absolute",
          left: "25%",
          top: "10%",
        }}
      >
        <ModalHeader
          title={"Salary Slip"}
          onClose={(data) => {
            setOpen(data);
          }}
        />

        <Divider />
        {/* <Grid container sx={{ position: "relative", p: "10px" }}>
          <Grid item xs={12}>
            <Typography
              color="primary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Payment Slipt for The Month Februwary
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="secondary" sx={{ marginRight: "20px" }}>
              Name
            </Typography>
            <Typography> {modalData?.emaployeeName}</Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Joining Date
            </Typography>
            <Typography></Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Designation
            </Typography>
            <Typography> </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Location
            </Typography>
            <Typography> </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Emp ID
            </Typography>
            <Typography>{modalData?.employeeId}</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography
              color="secondary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Earning
            </Typography>
            <Typography
              color="secondary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Actual
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Incentive Amount
            </Typography>
            <Typography sx={{ marginRight: "10px" }}>
              {modalData?.incentiveAmount}
            </Typography>
          </Grid>{" "}
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Total Earning: INR
            </Typography>
            <Typography sx={{ marginRight: "10px" }}>
              {modalData?.totalEarnings}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography
              color="secondary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Deduction
            </Typography>
            <Typography
              color="secondary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Actual
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Advance Paid
            </Typography>
            <Typography sx={{ marginRight: "10px" }}>
              {modalData?.advancePaid}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Total Deduction INR
            </Typography>
            <Typography sx={{ marginRight: "10px" }}>
              {modalData?.totalDeductions}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography
              color="primary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Net Pay for the month (Total Earnings - Total Decduction):
            </Typography>
            <Typography
              color="primary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              0.0
            </Typography>
          </Grid>
        </Grid> */}

        <Card sx={{ maxWidth: 600, mx: "auto", p: 1 , mt:2}}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  color="primary"
                  sx={{ fontWeight: "800", textAlign: "center" }}
                >
                  Payment Slip for The Month February
                </Typography>
              </Grid>

              <Grid item xs={12} sx={{ display: "flex", gap: 1 }}>
                <Typography color="secondary">Name:</Typography>
                <Typography>{modalData?.emaployeeName || "N/A"}</Typography>
              </Grid>

              <Grid item xs={12} sx={{ display: "flex", gap: 1 }}>
                <Typography color="secondary">Joining Date:</Typography>
                <Typography>{modalData?.joiningDate || "N/A"}</Typography>
              </Grid>

              <Grid item xs={12} sx={{ display: "flex", gap: 1 }}>
                <Typography color="secondary">Designation:</Typography>
                <Typography>{modalData?.designation || "N/A"}</Typography>
              </Grid>

              <Grid item xs={12} sx={{ display: "flex", gap: 1 }}>
                <Typography color="secondary">Location:</Typography>
                <Typography>{modalData?.location || "N/A"}</Typography>
              </Grid>

              <Grid item xs={12} sx={{ display: "flex", gap: 1 }}>
                <Typography color="secondary">Emp ID:</Typography>
                <Typography>{modalData?.employeeId || "N/A"}</Typography>
              </Grid>

              <Grid item xs={12} display={"flex"} justifyContent={"space-between"} sx={{ borderBottom: "1px solid #ddd", py: 1 }}>
                <Typography color="secondary" sx={{ fontWeight: "800" }}>
                  Earnings
                </Typography>
                <Typography color="secondary" sx={{ fontWeight: "800" }}>
                  Actual
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography color="secondary">Incentive Amount:</Typography>
                <Typography>{modalData?.incentiveAmount || "0.00"}</Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography color="secondary">Total Earning (INR):</Typography>
                <Typography>{modalData?.totalEarnings || "0.00"}</Typography>
              </Grid>

              <Grid item xs={12} display={"flex"} justifyContent={"space-between"} sx={{ borderBottom: "1px solid #ddd", py: 1 }}>
                <Typography color="secondary" sx={{ fontWeight: "800" }}>
                  Deductions
                </Typography>
                <Typography color="secondary" sx={{ fontWeight: "800" }}>
                  Actual
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography color="secondary">Advance Paid:</Typography>
                <Typography>{modalData?.advancePaid || "0.00"}</Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography color="secondary">
                  Total Deduction (INR):
                </Typography>
                <Typography>{modalData?.totalDeductions || "0.00"}</Typography>
              </Grid>

              <Grid item xs={12} sx={{ borderTop: "1px solid #ddd", py: 1 }}>
                <Typography
                  color="primary"
                  sx={{ fontWeight: "800", textAlign: "center" }}
                >
                  Net Pay for the Month (Total Earnings - Total Deduction):
                </Typography>
                <Typography
                  color="secondary"
                  sx={{ fontWeight: "800", textAlign: "center" }}
                >
                  {modalData?.totalEarnings - modalData?.totalDeductions ||
                    "0.00"}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};
